import { hasCapability, type User } from "../base";

export const aiSummary = {
  generate: (user: User) => hasCapability(user, "aiSummary.generate"),
  view: (user: User) => hasCapability(user, "aiSummary.view"),
};

export const aiChat = {
  generate: (user: User) => hasCapability(user, "aiChat.generate"),
};

export const aiBidAnalysis = {
  create: (user: User) => hasCapability(user, "aiBidAnalysis.create"),
  view: (user: User) => hasCapability(user, "aiBidAnalysis.view"),
};

export const aiFeedback = {
  create: (user: User) => hasCapability(user, "aiFeedback.create"),
  viewLink: (user: User) => hasCapability(user, "aiFeedback.viewLink"),
};

export const aiFileSummary = {
  view: (user: User) => hasCapability(user, "aiFileSummary.view"),
};
